import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textures = _resolveComponent("Textures")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["backgroundwrapper", _ctx.sectionClasses])
  }, [
    (_ctx.texture)
      ? (_openBlock(), _createBlock(_component_Textures, {
          key: 0,
          class: "backgroundwrapper__texture",
          type: _ctx.texture
        }, null, 8, ["type"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}